export const ADDRESS = `/address/`;
export const STATE_DETAILS = `/data/states/`;
export const STATE_DISTRICT = `/data/state/`;
export const DISTRICT_DETAILS = `/data/district/`;